module.exports = __webpack_public_path__ + "static/turquia-021-4677b7467864c307e919445f4605eda6.jpg";